import useMutation from "src/hooks/useMutation";

function useTPCreate() {
  return useMutation({
    path: "/api/v1/shipping-providers",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/shipping-providers`,
      shouldRevalidate: true,
    },
  });
}

export default useTPCreate;
